@if (loading) {
  <div class="loader"></div>
}
<div class="left-modal">
  <div class="close" (click)="close()"></div>
  <div class="modal-container">
    @if (!unit) {
      <h1>{{'Add unit' | translate}}</h1>
    }
    @if (unit) {
      <h1>{{'Edit unit' | translate}}</h1>
    }
  </div>
  <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
    @for (unit of units; track unit; let i = $index) {
      <div class="row">
        <div class="L-12 M-12 S-12 columns">
          <div class="L-6 M-6 S-6 columns">
            <label>{{'Unit' | translate}}**</label>
            <input type="text" name="{{'unit_number' + i}}" [(ngModel)]="unit.unit_number" [pattern]="_gS.regex.numberZero" maxlength="2" required>
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label>{{'Unit name' | translate}}</label>
            <input type="text" name="{{'unit_name' + i}}" [(ngModel)]="unit.unit_name">
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label>{{'Start date' | translate}}</label>
            <input type="date" name="{{'start_date' + i}}" [(ngModel)]="unit.start_date">
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label>{{'End date' | translate}}</label>
            <input type="date" name="{{'end_date' + i}}" [(ngModel)]="unit.end_date">
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label>{{'production center' | translate}}**</label>
            <app-dropdown
              [(appModel)]="unit.production_center_id"
              [list]="productionCenters"
              [value]="'id'"
              [name]="'prod_center'"
              [required]="true"
              [backTranslate]="true"
            ></app-dropdown>
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label >{{'Live view link' | translate}}</label>
            <input type="text" name="{{'live_view' + i}}" [(ngModel)]="unit.live_view" placeholder="https://example.com">
          </div>
          <div class="L-6 M-6 S-6 columns">
            <label >{{'Live chat link' | translate}}</label>
            <input type="text" name="{{'chat_view' + i}}" [(ngModel)]="unit.chat_view" placeholder="https://example.com">
          </div>
          <br>
            <div class="row">
              <h2>{{'Cameras' | translate}}</h2>
            </div>
            @if (validateCameras()) {
              <div class="errorMessage">{{'Invalid camera name' | translate}}</div>
            }
            @for (cam of unit.cameras; track cam; let ui = $index) {
              <div class="L-3 M-3 S-3 columns">
                <div class="form_with_button">
                  <div class="form_container">
                    <label>#{{ui + 1}}</label>
                    <input type="text" name="{{'camera' + ui}}" [(ngModel)]="cam.camera_name_eng" required>
                  </div>
                  <div class="form_button">
                    @if (cam.clips == 0) {
                      <span (click)="deleteCamera(ui, i)"></span>
                    }
                  </div>
                </div>
              </div>
            }
            <a class="addContainer" (click)="addCamera(i)">{{'Click to add new camera' | translate}}</a>
          </div>
        </div>
      }
      @if (units.length > 0) {
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Save' | translate}}" [disabled]="form.invalid || units[0].production_center_id == '' || validateCameras()">
        </div>
      }
      <div class="L-12 M-12 S-12 columns TextCentered">
        <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
      </div>
    </form>
  </div>